module.exports = __webpack_public_path__ + "img/androiddownload.3e86af27.png";